/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Save_LinkInputs */

const en_cap_save_link = /** @type {(inputs: Cap_Save_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try the example above`)
};

const lv_cap_save_link = /** @type {(inputs: Cap_Save_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izmēģiniet piemēru augstāk`)
};

/**
* | output |
* | --- |
* | "Try the example above" |
*
* @param {Cap_Save_LinkInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_save_link = /** @type {((inputs?: Cap_Save_LinkInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Save_LinkInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_save_link(inputs)
	return en_cap_save_link(inputs)
});